import "./pinned-flagship";

const FILTER_CHECKBOX = ".storemapper-filter-checkbox";
const FILTER_FIELDSET = ".strmpr-filter-fieldset";

// Storemapper stamps this on each filter checkbox, holding the label text without the trailing
// ", selected" / ", unselected" it appends to aria-label.
const BASE_LABEL_ATTRIBUTE = "data-storemapper-aria-label";

/**
 * Unchecks a filter and keeps the aria-label Storemapper derives from it in step.
 */
function uncheck(checkbox) {
  if (!checkbox.checked) return;

  checkbox.checked = false;

  const baseLabel = checkbox.getAttribute(BASE_LABEL_ATTRIBUTE);
  if (baseLabel) checkbox.setAttribute("aria-label", `${baseLabel}, unselected`);
}

// The design calls for one filter at a time, but Storemapper renders its categories as a
// multi-select set of checkboxes. Its own change listener sits on the fieldset and rebuilds the
// active tag list by reading every checkbox, so clearing the siblings here — during the capture
// phase, before that listener runs — is enough to make the selection exclusive in a single pass.
// Unchecking the active filter needs no special case: the list comes back empty and Storemapper
// falls back to showing every location.
document.addEventListener(
  "change",
  (event) => {
    const checkbox = event.target;
    if (!(checkbox instanceof HTMLInputElement) || !checkbox.matches(FILTER_CHECKBOX)) return;

    const fieldset = checkbox.closest(FILTER_FIELDSET);
    if (!fieldset) return;

    fieldset.querySelectorAll(FILTER_CHECKBOX).forEach((filter) => {
      if (filter !== checkbox) uncheck(filter);
    });
  },
  true,
);
